import { action } from 'typesafe-actions';
import { RegActionTypes } from './types';
import { RegistrationDataTypes, ConfirmationDataTypes } from 'types';

export const fetchRegInit = () => action(RegActionTypes.FETCH_REG_INIT);

export const fetchRegRequest = (data: RegistrationDataTypes) =>
  action(RegActionTypes.FETCH_REG_REQUEST, data);

export const fetchRegSuccess = (data: any) =>
  action(RegActionTypes.FETCH_REG_SUCCESS, data);

export const fetchRegError = (errors: string) =>
  action(RegActionTypes.FETCH_REG_ERROR, errors);

export const fetchRegConfirmationRequest = (data: ConfirmationDataTypes) =>
  action(RegActionTypes.FETCH_REG_CONFIRMATION_REQUEST, data);

export const fetchRegConfirmationSuccess = (data: any) =>
  action(RegActionTypes.FETCH_REG_CONFIRMATION_SUCCESS, data);

export const fetchRegConfirmationError = (errors: string) =>
  action(RegActionTypes.FETCH_REG_CONFIRMATION_ERROR, errors);
